import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatSort, MatPaginator, MatTableDataSource, MatSlideToggleChange } from '@angular/material';
import { EventsService } from '../../../_services/events.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AppConfig } from '../../../_helpers/index';
import { CustomerService } from '../../../_services';
import { EventsEdit, EventsSave, IEvents } from '../../../_models/eventsEdit.interface';

@Component({
    selector: 'events',
    templateUrl: './events.component.html',
    styleUrls: ['./events.component.css'],
    encapsulation: ViewEncapsulation.None
})

export class EventsComponent implements OnInit {
    public customer_public_id: string;
    searchFilterForm: FormGroup;
    displayedColumns: string[] = ['name', 'description', 'status', 'actions'];
    dataSource = new MatTableDataSource();
    isLoading = true;
    pageSize: number;
    PageSizeOptions: number[];
    color: any = 'primary';
    public custNotifyTemplateList: any;
    eventsEditForm: FormGroup;
    public User_publicid: string;
    ngenableCustomerEmail = false;
    ngenableCompanyemail = false;
    ngenableWebhook = false;
    keyValue: any;
    filterValue;
    eventsList = [];
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    configValues = [];

    templateListLimit: number = 100;

    constructor(private _fb: FormBuilder, private router: Router, private eventsService: EventsService,
        private spinnerService: Ng4LoadingSpinnerService
        , private customerService: CustomerService) {
        this.spinnerService.show();
        this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
        this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;
    }

    InitialSetup() {
        this.eventsEditForm = this._fb.group({
            customeremail: new FormControl(false),
            template: new FormControl(""),
            companyemail: new FormControl(false),
            webhook: new FormControl(false),
            public_id: new FormControl("")
        })

    }

    ngOnInit() {
        this.paginator._intl.itemsPerPageLabel = "Registros por página";
        this.paginator._intl.nextPageLabel = "siguiente página";
        this.paginator._intl.lastPageLabel = "última página";
        this.paginator._intl.previousPageLabel = "anterior página";
        this.paginator._intl.firstPageLabel = "primera página";

        let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
        if (browserStorage1 == null) {
            let browserStorage = localStorage.getItem('companyId');
            if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
                this.router.navigate(['/home']);
            }
            else {
                this.customer_public_id = localStorage.getItem('companyId');
            }
        }
        else {
            this.customer_public_id = localStorage.getItem('subcompanyId');
        }

        this.searchFilterForm = this._fb.group({
            searchText: ['', Validators.required]
        });

        this.InitialSetup();
        this.getEventsList();
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.getCustomerNotificationTemplateList(this.customer_public_id);
    }
    getEventsList() {
        this.eventsService.getEventsList(this.customer_public_id).subscribe(data => {
            this.isLoading = false;
            let resources = data["data"];
            this.eventsList =JSON.parse(JSON.stringify(resources))
            this.dataSource.data = resources;
            this.spinnerService.hide();
        },
            error => {
                this.isLoading = false;
                console.log('Failed while trying to the Customer Search All Result. ' + error);
            });
    }

    openActiveDialog(status, item) {
        this.spinnerService.show();
        const tempEventList = this.eventsList[this.eventsList.findIndex((x) => x.public_id === item.public_id)];
        tempEventList.status = status;
        this.eventsService.updateEventsStatus(item.public_id, tempEventList).subscribe(data => {
                this.getEventsList();
        },
            error => {
                console.log('Failed while trying to the Search All Result. ' + error);
            });
    }

    getCustomerNotificationTemplateList(public_id: string) {
        this.customerService.getCustomerNotificationTemplateList(this.customer_public_id, this.templateListLimit)
            .subscribe(data => {
                if (data && Array.isArray(data)) {
                    this.custNotifyTemplateList = data.filter(item => item.status == 'ACTIVE');
                } else {
                    this.custNotifyTemplateList = [];
                }
            }, error => {
                this.custNotifyTemplateList = [];
            });

    }

    editEventDetails(element) {
        this.spinnerService.show();
        this.InitialSetup();
        this.User_publicid = element.public_id;
        var temptemplateValue = "";
        this.ngenableCustomerEmail = false;
        this.ngenableCompanyemail = false;
        this.ngenableWebhook = false;
        this.eventsService.getEventDetails(this.User_publicid).subscribe((data: EventsEdit) => {

            for (var i = 0; i < data.values.length; i++) {
                if (data.key == "invoice.created" || data.key == "invoice.paid" || data.key == "invoice.rejected") {
                    if (data.values[i].type == "customer_email") {
                        this.ngenableCustomerEmail = true;
                    }
                    if (data.values[i].template_id != undefined) {
                        temptemplateValue = data.values[i].template_id;
                    }
                }
                if (data.values[i].type == "email") {
                    this.ngenableCompanyemail = true;
                }
                if (data.values[i].type == "webhook") {
                    this.ngenableWebhook = true;
                }


            }
            this.configValues = data.values;
            this.keyValue = data.key;
            this.eventsEditForm = this._fb.group({
                customeremail: new FormControl(this.ngenableCustomerEmail),
                template: new FormControl(temptemplateValue),
                companyemail: new FormControl(this.ngenableCompanyemail),
                webhook: new FormControl(this.ngenableWebhook),
                public_id: new FormControl(data.public_id)
            })
            this.spinnerService.hide();
        });

    }
    onsubmitEventEditDetailsForm({ value }: { value: EventsSave }) {
        this.spinnerService.show();
        let tempjsonValue = this.configValues;
        if (this.keyValue == "invoice.created" || this.keyValue == "invoice.paid" || this.keyValue == "invoice.rejected" || this.keyValue == "invoice.create_partial" || this.keyValue == "invoice.paid_partial") {
            if (value.customeremail == true) {
                if (tempjsonValue.findIndex(item => item.type == 'customer_email') == -1) {
                    tempjsonValue.push({ "type": "customer_email", "template_id": value.template });
                } else {
                    //update the template id from the form when the customer_email already exists in the array..
                    tempjsonValue[tempjsonValue.findIndex(item => item.type == 'customer_email')].template_id = value.template;
                }
            } else {
                if (tempjsonValue.findIndex(item => item.type == 'customer_email') != -1) {
                    tempjsonValue.splice(tempjsonValue.findIndex(item => item.type == 'customer_email'), 1);
                }
            }
        }

        if (value.companyemail == true) {
            if (tempjsonValue.findIndex(item => item.type == 'email') == -1) {
                tempjsonValue.push({ "type": "email" });
            }
        } else {
            if (tempjsonValue.findIndex(item => item.type == 'email') != -1) {
                tempjsonValue.splice(tempjsonValue.findIndex(item => item.type == 'email'), 1);
            }
        }

        if (value.webhook == true) {
            if (tempjsonValue.findIndex(item => item.type == 'webhook') == -1) {
                tempjsonValue.push({ "type": "webhook" })
            }
        } else {
            if (tempjsonValue.findIndex(item => item.type == 'webhook') != -1) {
                tempjsonValue.splice(tempjsonValue.findIndex(item => item.type == 'webhook'), 1);
            }
        }
        var val = { "values": tempjsonValue };

        this.eventsService.updateEvents(value.public_id, val).subscribe(data => {
                this.getEventsList();
        },
            error => {

                console.log('Failed while trying to the onsubmitEventEditDetailsForm. ' + error);
            });

    }
    customerEmailToggle(event: MatSlideToggleChange) {
        if (!event.checked) {
            this.eventsEditForm.get('template').setValue("");
            this.eventsEditForm.get('template').clearValidators();
            this.eventsEditForm.get('template').updateValueAndValidity();
        }
        else {
            this.eventsEditForm.get('template').setValidators([Validators.required]);
            this.eventsEditForm.get('template').updateValueAndValidity();
        }
    }

    applyFilter() {
        this.filterValue = this.searchFilterForm.controls.searchText.value;
        this.dataSource.filter = this.filterValue;
    }
}
